import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

export default {
  getPosition(params) { //活跃度预警查询
    const url =  baseURL+'/enterprise/loadRatio/requestMap?cityName='+params.city+'&districtName='+params.area+'&token='+params.token+'&checkCode='+params.checkCode;
    return axios.get(url);
  },
  getaddressfromposition(params){
    const url = baseURL+'/enterprise/loadRatio/requestGetMapByLongitude?location='+params.pos.toString()+'&token='+params.token+'&checkCode='+params.checkCode;
    return axios.get(url)
  }
}


// WEBPACK FOOTER //
// ./src/api/positionApi.js